<template>
  <div>
    <carousel
      :per-page="perPage"
      :navigation-enabled="true"
      :pagination-enabled="enablePagination || smallScreen"
      :pagination-tagging="true"
      :swipe-on-desktop="false"
      :start-at="0"
      :autoplay="false"
      :infinite-navigation="false"
      :labels="alts"
    >
      <slot />

      <svg
        slot="customPrevIcon"
        class="icon icon-prev"
        viewBox="0 0 100 100"
      >
        <use xlink:href="#arrow-right" />
      </svg>

      <svg
        slot="customNextIcon"
        class="icon icon-next"
        viewBox="0 0 100 100"
      >
        <use xlink:href="#arrow-right" />
      </svg>
    </carousel>
  </div>
</template>

<script>
  import Carousel from '@Feature/Carousel/code/Scripts/components/carousel/carousel.vue';
  import { throttle } from '@Foundation/utilities';

  export default {
    name: 'ProductSlider',
    components: {
      Carousel
    },
    props: {
      alts: { type: Object, required: true },
      numberOfSlidesDesktop: { type: Number, required: false, default: null },
      enablePagination: { type: Boolean, required: false }
    },
    data() {
      return {
        smallScreen: !window.matchMedia('(min-width: 1025px)').matches,
        tablet: window.matchMedia('(min-width: 768px)').matches
      };
    },
    computed: {
      perPage() {
        return this.smallScreen ? (this.tablet ? 2 : 1) : (this.numberOfSlidesDesktop ? this.numberOfSlidesDesktop : 4);
      }
    },
    mounted() {
      /* istanbul ignore next */
      window.addEventListener('resize', throttle(() => {
        this.smallScreen = !window.matchMedia('(min-width: 1025px)').matches;
        this.tablet = window.matchMedia('(min-width: 768px)').matches;
      }, 100));
    }
  };
</script>
